import { useLocation } from "react-router-dom";
import { UserCircle, SignOut } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const AccountButton = () => {
  const { user, loading, openSignIn, logout } = useAuth();
  const { pathname } = useLocation();
  // Kids Hub never shows sign-in prompts.
  if (pathname.startsWith("/kids") && !user) return null;
  if (loading) return <span className="h-10 w-10" aria-hidden="true" />;

  if (!user) {
    return (
      <button
        data-testid="account-signin-btn"
        onClick={() => openSignIn("account")}
        className="flex items-center gap-2 border border-white/10 px-2.5 sm:px-3.5 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] text-white/70 hover:border-amber hover:text-amber transition-colors duration-300"
      >
        <UserCircle size={16} weight="duotone" />
        <span className="rv-hdr-label hidden sm:inline xl:hidden 2xl:inline whitespace-nowrap">Sign in</span>
      </button>
    );
  }

  const initial = (user.name || user.email || "?").charAt(0).toUpperCase();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="account-menu-trigger"
        className="flex h-10 w-10 items-center justify-center overflow-hidden border border-amber/50 bg-amber/10 font-mono text-sm text-amber hover:border-amber transition-colors duration-300"
        aria-label="Account"
      >
        {user.picture ? <img src={user.picture} alt="" className="h-full w-full object-cover" referrerPolicy="no-referrer" /> : initial}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[220px] rounded-none border-white/10 bg-[#0A0A0A] text-[#EDEDED]">
        <DropdownMenuLabel>
          <p data-testid="account-name" className="text-sm text-white/90 truncate">{user.name}</p>
          <p data-testid="account-email" className="font-mono text-[10px] text-white/40 truncate">{user.email}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        <DropdownMenuItem data-testid="account-logout" onClick={logout} className="cursor-pointer font-mono text-[11px] uppercase tracking-[0.12em] focus:bg-white/5 focus:text-amber">
          <SignOut size={14} className="mr-2" /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
